export default __webpack_public_path__ + "static/media/spinner.35ada5a9.webp";